module.exports = __webpack_public_path__ + "img/klipy-logo-light.6b8a556.png";